(() => {
  function init(root = document) {
    root.querySelectorAll('[data-cal-reviews]:not([data-ready])').forEach(section => {
      const tabs = [...section.querySelectorAll('[data-review-language]')];
      const panels = [...section.querySelectorAll('[data-review-panel]')];
      const select = tab => {
        tabs.forEach(item => {
          item.setAttribute('aria-selected', String(item === tab));
          item.tabIndex = item === tab ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.dataset.reviewPanel !== tab.dataset.reviewLanguage; });
        const french = tab.dataset.reviewLanguage === 'fr';
        section.querySelector('h2').textContent = french ? 'Les avis de nos clients' : 'Customer stories';
        const rating = section.querySelector('.cal-rating');
        if (rating) {
          const score = rating.querySelector('strong');
          const number = score.firstChild;
          number.textContent = french ? number.textContent.replace('.', ',') : number.textContent.replace(',', '.');
          const count = rating.querySelector('.cal-rating-count');
          const total = count.textContent.trim().split(' ')[0];
          count.textContent = total + (french ? ' avis' : ' reviews');
          rating.setAttribute('aria-label', number.textContent + (french ? ' sur 5, ' : ' out of 5, ') + count.textContent);
        }
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(index + tabs.length - 1) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          event.preventDefault();
          select(next);
          next.focus();
        });
      });
      select(tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
      section.querySelector('[data-review-tabs]').hidden = false;
      section.dataset.ready = 'true';
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
